<template>
	<div class="home">
		<headeradmin ref="headerCompRef" v-if="userInfo?.email" :positionFixed="true" :languageData="languageData"></headeradmin>
		<headerComp ref="headerCompRef" :positionFixed="true" :languageData="languageData" v-else></headerComp>
		<div class="homeMain">
			<section class="bannerBox">
				<img class="img" src="@/assets/banner.png" alt="" srcset="">
				<div class="content">
					<div class="info">
						<div class="title">
							<div class="t">{{languageData.banner标题1}}</div>
							<img class="icon" src="@/assets/i1.png" alt="" srcset="">
						</div>
						<h1 class="h4" v-html="languageData.banner标题2"></h1>
					</div>
				</div>
			</section>
			<section class="serviceBox">
				<div class="title">
					<div class="text" v-html="languageData.T01标题"></div>
				</div>
				<div class="dataBlock">
					<div class="content">
						<div class="titleBox">
							<div class="num">01.</div>
							<div class="t" v-html="languageData.T01标题1"></div>
						</div>
						<div class="infoBox">
							<div class="topMinText">{{languageData.T01标题2}}</div>
							<div class="rigth">
								<div class="item">
									<div class="tt">
										<img class="i" src="@/assets/i6.png" alt="" srcset="">
										<div class="t">{{languageData.item1标题}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item1标题_子1}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item1标题_子2}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item1标题_子3}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item1标题_子4}}</div>
									</div>
								</div>
								<div class="item">
									<div class="tt">
										<img class="i" src="@/assets/i7.png" alt="" srcset="">
										<div class="t">{{languageData.item2标题}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item2标题_子1}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item2标题_子2}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item2标题_子3}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item2标题_子4}}</div>
									</div>
								</div>
								<div class="item">
									<div class="tt">
										<img class="i" src="@/assets/i8.png" alt="" srcset="">
										<div class="t">{{languageData.item3标题}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item3标题_子1}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item3标题_子2}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item3标题_子3}}</div>
									</div>
									<div class="ss">
										<img class="i" src="@/assets/i9.png" alt="" srcset="">
										<div class="t">{{languageData.item3标题_子4}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="dataLine">
						<img class="img2" src="@/assets/i4.png" alt="" srcset="">
						<div class="t1">{{ languageData.L历史数据 }}</div>
						<div class="t2">{{ languageData.L未来预测 }}</div>
					</div>
				</div>
				<div  class="dataBlock3">
					<div class="blockOne">
						<div class="left">
							<div class="titleT">{{languageData.Market标题}}</div>
							<div class="btn" @click="MethodologyUrl()">
								<div class="t">{{languageData.learnMore}}</div>
								<img class="icon" src="@/assets/i130.png" alt="" srcset="">
							</div>
						</div>
						<div class="right">
							<div class="itemT">
								<div class="iconT">
									<img class="icon" src="@/assets/i127.png" alt="" srcset="">
									<div class="t">{{languageData.OurPeople}}</div>
								</div>
								<div class="text">{{languageData.OurPeople描述}}</div>
							</div>
							<div class="itemT">
								<div class="iconT">
									<img class="icon" src="@/assets/i128.png" alt="" srcset="">
									<div class="t">{{languageData.Methodology}}</div>
								</div>
								<div class="text">{{languageData.Methodology描述}}</div>
							</div>
							<div class="itemT">
								<div class="iconT">
									<img class="icon" src="@/assets/i129.png" alt="" srcset="">
									<div class="t">{{languageData.IndustryExpertise}}</div>
								</div>
								<div class="text">{{languageData.IndustryExpertise描述}}</div>
							</div>
						</div>
					</div>
					<div class="blockTwo">
						<div class="titleT">{{languageData.experts标题}}</div>
						<div class="text">{{languageData.experts描述}}</div>
						<div class="btnT">
							<div class="tt" @click="onshowLogin(languageData.experts按钮)">{{languageData.experts按钮}}</div>
						</div>
					</div>
				</div>
				<div class="dataBlock4">
					<div class="content">
						<div class="titleBox">
							<div class="num">02.</div>
							<div class="t">
								<div class="tt">{{languageData.T02标题}}</div>
							</div>
							<div class="btnT">
								<div class="tt" @click="onshowLogin(languageData.T02标题按钮)">{{languageData.T02标题按钮}}</div>
							</div>
						</div>
						<div class="ts">{{languageData.T02标题2}}</div>
						<div class="swiperBox">
							<swiper :modules="modules" @swiper="onSwiper" :slides-per-view="3"  :loop="true">
								<swiper-slide v-for="(item,index) in getenindexData" :key="index">
									<div class="itemBoxT" @click="chanPing(item)">
										<div class="itemBox">
											<img class="imgBg" :src="item.imgurl" alt="" srcset="">
											<div class="titleT">{{item.title}}</div>
											<div class="tt">{{item.title_desc}}</div>
											<div class="itBox">
												<div class="it" v-for="(items,indexs) in item.labers" :key="indexs">
													<img class="i" src="@/assets/i133.png" alt="" srcset="">
													<div class="t">{{items}}</div>
												</div>
											</div>
											<div class="btn" >
												<div class="t">{{languageData.learnMore}}</div>
												<img class="icon" src="@/assets/i130.png" alt="" srcset="">
											</div>
										</div>
									</div>
								</swiper-slide>
							</swiper>
							<view class="prevSlide" @click="prevSlide"></view>
							<view class="nextSlide" @click="nextSlide"></view>
						</div>
						<div class="itemBoxTb">
							<div class="t">{{languageData.T02定制标题}}</div>
							<div class="itemBoxNum">
								<div class="itemT">
									<div class="item">
										<div class="num">{{languageData.T02定制Manufacturers数量}}</div>
										<div class="lable">{{languageData.T02定制Manufacturers}}</div>
									</div>
									<div class="msg" v-html="languageData.T02定制Manufacturers描述"></div>
								</div>
								<div class="itemT">
									<div class="item">
										<div class="num">{{languageData.T02定制Experts数量}}</div>
										<div class="lable">{{languageData.T02定制Experts}}</div>
									</div>
									<div class="msg" v-html="languageData.T02定制Experts描述"></div>
								</div>
								<div class="itemT">
									<div class="item">
										<div class="num">{{languageData.T02定制Customers数量}}</div>
										<div class="lable">{{languageData.T02定制Customers}}</div>
									</div>
									<div class="msg" v-html="languageData.T02定制Customers描述"></div>
								</div>
								<div class="itemT">
									<div class="item">
										<div class="num">{{languageData.T02定制QualityAssurance}}</div>
									</div>
									<div class="msg" v-html="languageData.T02定制QualityAssurance描述"></div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				<div class="dataBlock5">
					<div class="content">
						<div class="conentTT">
							<div class="titleT">{{languageData.T02定制say标题}}</div>
							<div class="info">{{languageData.T02定制say描述}}</div>
						</div>
					</div>
				</div>
				<div class="dataBlock6">
					<div class="content">
						<div class="itemBox">
							<div class="left">
								<div class="t">{{languageData.T02定制Ready标题}}</div>
								<div class="m">{{languageData.T02定制Ready描述}}</div>
							</div>
							<div class="btnT">
								<div class="tt" @click="onshowLogin(languageData.T02定制Ready按钮)">{{languageData.T02定制Ready按钮}}</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="newsBox">
				<div class="title">
					<div class="text">{{languageData.new新闻标题}}</div>
				</div>
				<div class="content">
					<div class="navBox">
						<div class="btn" v-for="(item,index) in aticleSorts" :class="navIdx == index?'active':''" @click="onNav(index)">{{item.type}}</div>
					</div>
					<div class="newBox" v-if="total > 0 || aticleData?.topitem?.id">
						<div class="left" v-if="aticleData?.topitem"  @click="IndustrialDetails(aticleData?.topitem)">
							<div class="imgBox">
								<img class="img" :src="aticleData?.topitem.imgurl" alt="" srcset="">
							</div>
							<div class="titleT">{{ aticleData?.topitem.title }}</div>
							<div class="msg" >{{ aticleData?.topitem.content_txt }}</div>
							<div class="time">{{ aticleData?.topitem.create_time}}</div>
						</div>
						<div class="line" v-if="aticleData?.topitem"></div>
						<div class="right">
							<div class="list" v-for="(item,index) in aticleData3" :key="index" @click="IndustrialDetails(item)">
								<div class="info">
									<div class="t">{{ item.title }}</div>
									<div class="m">{{ item.content_txt }}</div>
								</div>
								<div class="moreTime">
									<div class="time">{{ item.create_time }}</div>
									<div class="more">
										<div class="t">{{languageData.learnMore}}</div>
										<img class="i" src="@/assets/i34.png" alt="" srcset="">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="noData noData2" v-else>
						<img class="i" src="@/assets/quesheng.png" alt="" srcset="" >
						<div class="t">{{languageData.C暂无数据}}</div>
					</div>
				</div>
				<div class="pagination" v-if="total > 0  || aticleData?.topitem?.id">
					<el-pagination layout="prev, pager, next" v-model:current-page="page" :total="total" :page-size="3" @change="changePage" />
				</div>
			</section>
		</div>
		<footerComp></footerComp>
	</div>
</template>

<script lang="ts">
import { defineComponent,ref,onMounted,onUnmounted,watch ,nextTick} from 'vue';
import headerComp from '@/components/header.vue'
import headeradmin from '@/components/headeradmin.vue'
import footerComp from '@/components/footer.vue'
import {postApi,getApi} from '@/utils/index'
import { useRouter,useRoute } from "vue-router"
import { ElMessage } from 'element-plus'

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation} from 'swiper/modules';
import 'swiper/swiper-bundle.css';
type SwiperInstance = InstanceType<typeof Swiper>;
export default defineComponent({
	name: 'HomeView',
	components: {
		headerComp,
		footerComp,
		headeradmin,
		Swiper,
    	SwiperSlide,
	},
	setup() {
		const modules = [Navigation];
		const swiper = ref(<any>null);


		const navIdx:any = ref(0)
		const aticleData:any = ref([])
		const aticleData3:any = ref([])
		const aticleSorts:any = ref([])
		const indexNav:any = ref([])
		const userInfo:any = ref()
		const total:any = ref(0)
		const navTopId = ref(<any>'')
		const languageData = ref(<any>{})
		const formData = ref({
			phone: '',
			password: '',
			password2: '',
			code: '',
			company: '',
			position: '',
			name: ''
		})
		const showLogin = ref(false)
		const time = ref('发送验证码')
		const currentTime = ref(60)
		const interval = ref(0)
		const disabledT = ref(false)
		const page = ref(1)

		const onSwiper = (swiperInstance: any) => {
			swiper.value = swiperInstance; // 存储 swiper 实例到 ref 中
		};
	
		const prevSlide = () => {
			if (swiper.value) {
				swiper.value.slidePrev(); // 调用 slidePrev 方法
			} else {
				ElMessage.error(languageData.value.C暂无数据)
			}
		};
		const nextSlide = () => {
			if (swiper.value) {
				swiper.value.slideNext(); // 调用 slidePrev 方法
			} else {
				ElMessage.error(languageData.value.C暂无数据)
			}
		};


		const onNav = (index:any) => {
			navIdx.value = index
			page.value = 1
			getArticle()
		}
		// 产品列表
		const getenindexData:any = ref([])
		const getenindex = async () => {
			let res = await getApi('/api/index/getenindex',{})
			getenindexData.value = res.data
			nextTick(() => {
				if (swiper.value) {
					swiper.value.update()
					swiper.value.slideTo(0, 0)
				}
			});

		}
		// 产业动态
		const getArticleSorts = async () => {
			let res = await getApi('/api/Article/gethome',{})
			aticleSorts.value = res.data.sorts
			aticleSorts.value[navIdx.value].type
			getArticle()
		}
		const changePage = (e: any) => {
			page.value = e
			getArticle()
		}
		const getArticle = async () => {
			let data:any = {
				type: aticleSorts.value[navIdx.value].type,
				page: page.value
			}
			let res = await getApi('/api/Article/gethome',data)
			aticleData.value = res.data
			aticleData3.value = res.data.lists.data
			total.value = res.data.lists.total
		}
		const router = useRouter()
		const route = useRoute();
		const headerCompRef:any = ref(null)
		const IndustrialDetails = (item:any) => {

			if (item.sorts && item.sorts.status == 1) {
				if (!userInfo.value.email) {
					if (headerCompRef.value) {	
						headerCompRef.value.onshowLogin(1,`/articleDetails?id=${item.id}&type=${navIdx.value}`)
					}
				} else {
					const routeUrl = router.resolve(`/articleDetails?id=${item.id}&type=${navIdx.value}`).href
    				window.open(routeUrl, '_blank');
				}
			} else {
				const routeUrl = router.resolve(`/articleDetails?id=${item.id}&type=${navIdx.value}`).href
    			window.open(routeUrl, '_blank');
			}
			
		}
		const onshowLogin = (val:any) => {
			if (headerCompRef.value) {
				headerCompRef.value.onshowLogin(3,null,val)
			}
		}
		const languagGet = async () => {
			if (localStorage.getItem('languageData')){
				languageData.value = JSON.parse(localStorage.getItem('languageData') || '')
			}
		
		}
		const MethodologyUrl = () => {
			const routeUrl = router.resolve(`/articleDetailsd?code=Price data, forecasts, insights, and events for the rare earth magnet industry`).href
			window.open(routeUrl, '_blank');
		}
		const chanPing = (item:any) => {
			if(item.url){
				window.open(item.url, '_blank');
			} else {
				ElMessage.error(languageData.value.C暂无数据)
			}
			
		}
		const languageGetNew = async () => {
			let resLang:any = await getApi('/api/define/language',{})
			languageData.value = resLang.data
			localStorage.setItem('languageData',JSON.stringify(resLang.data))
		}
		onMounted(async () => {
			getArticleSorts()
			getenindex()
			let userInfoT = localStorage.getItem('userInfo') || ''
			userInfo.value  = userInfoT?JSON.parse(userInfoT):{}

			if (localStorage.getItem('languageData') != null){
				languagGet()
			} else {
				languageGetNew()
			}
			
			
		})
		watch(route, (newValue, oldValue) => {
		
			if (newValue){
				languagGet()
				let userInfoT = localStorage.getItem('userInfo') || ''
				userInfo.value  = userInfoT?JSON.parse(userInfoT):{}

			}
			
		})
		return {
			languageData,
			navIdx,
			onNav,
			aticleData,
			total,
			IndustrialDetails,
			userInfo,
			indexNav,
			navTopId,
			formData,
			showLogin,
			onshowLogin,
			disabledT,
			time,
			aticleSorts,
			changePage,
			headerCompRef,
			page,
			modules, 
			onSwiper, 
			prevSlide,
			nextSlide,
			MethodologyUrl,
			getenindexData,
			chanPing,
			aticleData3
		}
	}
});
</script>
<style lang="scss" scoped>
.homeMain{
	min-width: 1380px;
	margin: auto;
}
.bannerBox{
	position: relative;
	.img{
		width: 100%;
	}
	.content{
		position: absolute;
		left: 9rem;
		top: 13rem;
		.info{
			.title{
				display: flex;
				align-items: center;
				margin-bottom: -1rem;
				.t{
					font-size: 2.5rem;
					font-family: 'HarmonyOS_Sans_SC_Bold';
					color: #1F1F1F;
					line-height: 4.5rem;
				}
				.tt{
					font-size: 2.5rem;
					font-family: 'HarmonyOS_Sans_SC_Bold';
					background: radial-gradient(159% 159% at 29% -68%, rgba(253, 224, 209, 0.8) 26%, rgba(254, 207, 150, 0.304) 58%, rgba(243, 86, 55, 0) 99%), #F34F5A;
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					background-clip: text;
					text-fill-color: transparent;
					margin-left: .6rem;
				}
				.icon{
					width: 5.6rem;
					margin-left: -1.8rem;
				}
			}
			.h1{
				font-size: 2.5rem;
				font-family: 'HarmonyOS_Sans_SC_Bold';
				color: #1F1F1F;
				margin: 0;
				line-height: 4.5rem;
			}
			.h4{
				font-size: 2.5rem;
				color: #1F1F1F;
				margin: 0;
				line-height: 4.5rem;
			}
		}
	}
}
.serviceBox{
	.title{
		text-align: center;
		background-image: url('@/assets/i2.png');
		height: 10rem;
		background-repeat: no-repeat;
		background-size: cover;
		.text{
			font-size: 2.75rem;
			color: #1F1F1F;
			padding-top: 3rem;
			font-family: 'HarmonyOS_Sans_SC_Bold';
		}
	}
	.dataBlock{
		padding: 0 9rem;
		.dataLine{
			position: relative;
			margin-top: 0rem;
			.img1{
				width: 95%;
				position: absolute;
				left: 50%;
				bottom: 5rem;
				z-index: 10;
				transform: translate(-50%, 0);
				
			}
			.img2{
				width: 100%;
				position: relative;
				top: -2.5rem;
			}
			.t1{
				font-size: 1rem;
				font-family: 'HarmonyOS_Sans_SC_Medium';
				letter-spacing: 0em;
				font-weight: 500;
				background: linear-gradient(151deg, rgba(255, 124, 98, 0.5) 32%, rgba(0, 0, 0, 0) 67%), #1F1F1F;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				background-clip: text;
				position: absolute;
				left: 7.8%;
    			bottom: 15.5%;
			}
			.t2{
				font-size: 1rem;
				font-family: 'HarmonyOS_Sans_SC_Medium';
				letter-spacing: 0em;
				font-weight: 500;
				background: linear-gradient(151deg, rgba(255, 124, 98, 0.5) 32%, rgba(0, 0, 0, 0) 67%), #1F1F1F;
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				background-clip: text;
				position: absolute;
				right: 2%;
    			bottom: 15.5%;
			}
		}
		.content{
			padding: 4rem 4.2rem 4rem 4.2rem;
			position: relative;
			z-index: 9;
			margin: -1.5rem 0 0 0;
			box-shadow: 0px 8px 30px 5px rgba(121, 113, 110, 0.1);
			.titleBox{
				display: flex;
				align-items: center;
				position: relative;
				z-index: 999;
				padding-bottom: 2.8rem;
				&::after{
					content: '';
					background: linear-gradient(to right, rgba(255, 255, 255, 0) 92%, #FFFFFF 99%), linear-gradient(to right, #FFFFFF 0%, rgba(255, 255, 255, 0) 12%), #B0B0B0;
					position: absolute;
					width: 100%;
					left: 0;
					bottom: 0;
					height: 1px;
					opacity: 0.3;
				}
				
				.num{
					font-size: 3.8rem;
					color: #F73100;
					font-family: '900Heavy';
					width: 4.1rem;
				}
				.t{
					font-size: 2.3rem;
					color: #1F1F1F;
					font-weight: 400;
					margin-left: 1.6rem;
					flex: 1;
					font-family: 'HarmonyOS_Sans_SC_Bold';
				}
				.btnT{
					
					background-color: #F73100;
					width: 12rem;
					text-align: center;
					line-height: 2.8rem;
					border-radius: .2rem;
					position: relative;
					cursor: pointer;
					z-index: 9999;
					margin-left: .3rem;
					&:hover{
						.showCode{
							display: block;
						}
					}
					.tt{
						font-size: .9rem;
						color: #fff;
					}
					.showCode{
						position: absolute;
						top: 3rem;
						left: 0;
						width: 100%;
						display: none;
						.text{
							position: absolute;
							width: 100%;
							text-align: center;
							left: 0;
							top: 1.2rem;
							.s{
								font-size: .9rem;
								color: #fff;
							}
						}
						.img{
							width: 100%;
							padding-top: .3rem;
						}
					}
				}
			}
			.infoBox{
				margin-top: 2.8rem;
				
				.topMinText{
					font-size: 1.6rem;
					font-family: 'HarmonyOS_Sans_SC_Bold';
					margin-bottom: 2.8rem;
					line-height: 2.8rem;
					padding: 0 5.7rem;
				}
				.rigth{
					display: flex;
					padding-left: 5.7rem;
					.item{
						padding-right: 2.5rem;
						flex: 1;
						.tt{
							display: flex;
							align-items: center;
							margin-bottom: 1.2rem;
							.i{
								width: 1.2rem;
							}
							.t{
								font-size: 1.3rem;
								font-family: 'HarmonyOS_Sans_SC_Medium';
								color: #1F1F1F;
								flex: 1;
								margin-left: .6rem;
							}
						}
						.ss{
							display: flex;
							align-items: center;
							margin-bottom: .8rem;
							&:last-child{
								margin-bottom: 0;
							}
							.i{
								width: 1.2rem;
							}
							.t{
								font-size: 1rem;
								color: #1F1F1F;
								margin-left: .6rem;
								font-family: 'HarmonyOS_Sans_SC_Medium'
							}
						}
					}
				}
				.left{
					.line{
						width: 2.2rem;
						height: .4rem;
						opacity: 0.3;
						background: linear-gradient(to right, rgba(255, 255, 255, 0) 92%, #FFFFFF 99%), linear-gradient(to right, #FFFFFF 0%, rgba(255, 255, 255, 0) 12%), #B0B0B0;
					}
					.text{
						font-size: .9rem;
						line-height: 2.2rem;
						color: #1F1F1F;
						margin-top: 1.5rem;
					}
				}
			}
		}
	}
	.dataBlock2{
		padding: 0 5rem;
		margin-top: 4.8rem;
		.content{
			padding: 3rem 4.1rem;
			background-image: url('@/assets/i15.png');
			background-size: 100% 100%;
			background-repeat: no-repeat;
			position: relative;
			z-index: 9;
			background-color: rgba(255, 255, 255, 0.9);
			backdrop-filter: blur(20px);
			box-shadow: 0px 8px 20px 5px rgba(121, 113, 110, 0.1);
			margin: 0 4rem;
			.titleBox{
				display: flex;
				align-items: center;
				padding-bottom: 3.75rem;
				border-bottom: solid 1px rgba(176, 176, 176, 0.2);
				.num{
					font-size: 3.8rem;
					color: #F73100;
					font-family: '900Heavy'
				}
				.t{
					color: #1F1F1F;
					font-weight: 400;
					margin-left: 1.2rem;
					flex: 1;
					.tt{
						font-size: 1.4rem;
						font-family: "HarmonyOS_Sans_SC_Bold";
					}
					.ts{
						font-size: .8rem;
						margin-top: .3rem;
						font-weight: 400;
					}
				}
				.btnT{
					font-size: .9rem;
					color: #fff;
					background-color: #F73100;
					width: 12rem;
    				line-height: 2.8rem;
					border-radius: .2rem;
					margin-left: .3rem;
					position: relative;
					text-align: center;
					cursor: pointer;
					z-index: 999;
					&:hover{
						.showCode{
							display: block;
						}
					}
					.tt{
						font-size: .9rem;
						color: #fff;
					}
					.showCode{
						position: absolute;
						top: 3rem;
						left: 0;
						width: 100%;
						display: none;
						.text{
							position: absolute;
							width: 100%;
							text-align: center;
							left: 0;
							top: 1.2rem;
							.s{
								font-size: .9rem;
								color: #fff;
							}
						}
						.img{
							width: 100%;
							padding-top: .3rem;
						}
					}
				}
			}
			.itemBoxNum{
				display: flex;
				margin-top: 3.75rem;
				justify-content: center;
				padding: 0 3.2rem;
				.item{
					padding: .4rem;
					background-image: url('@/assets/i14.png');
					background-repeat: no-repeat;
					background-size: 1.6rem 1.6rem;
					background-position: .1rem .4rem;
					margin: auto;
					color: #1F1F1F;
					.num{
						font-size: 1.7rem;
						font-family: '800ExtraBold'
					}
					.lable{
						font-size: .8rem;
						margin-top: .3rem;
						color: #767676;
					}
				}
			}
		}
		.imgBox{
			display: flex;
			margin-top: -2.5rem;
			position: relative;
			.item{
				flex: 1;
				margin-right: 1.2rem;
				position: relative;
				&:last-child{
					margin-right: 0;
				}
				.img{
					width: 100%;
				}
				.titleB{
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					left: 0;
					bottom: 0;
					width: 100%;
					background: radial-gradient(138% 138% at 50% 0%, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(82% 82% at 50% 0%, rgba(229, 206, 159, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
					backdrop-filter: blur(1.5rem);
					padding: 1.3rem 0;
					.i1{
						width: 1.3rem;
					}
					.i2{
						width: 1.3rem;
						transform: rotate(180deg);
					}
					.t{
						font-size: 1rem;
						color: #1F1F1F;
						margin: 0 .7rem;
					}
				}
			}
		}
	}
	.dataBlock3{
		padding: 0 9rem;
		margin-top: 2rem;
		.blockTwo{
			margin-top: 5rem;
			padding: 0 4.2rem;
			.titleT{
				font-size: 2.3rem;
				font-family: 'HarmonyOS_Sans_SC_Bold';
				line-height: 1.6rem;
			}
			.text{
				font-size: 1.4rem;
				line-height: 2.8rem;
				margin-top: 2rem;
			}
			.btnT{
				margin-top: 1.8rem;
				position: relative;
				display: flex;
				z-index: 999;
				.tt{
					font-size: 1rem;
					background-color: #F73100;
					padding: .8rem 1.2rem;
					border-radius: 0.1rem;
					color: #fff;
					font-family: 'HarmonyOS_Sans_SC_Medium';
					cursor: pointer;
				}
			}
		}
		.blockOne{
			display: flex;
			align-items: center;
			.right{
				flex: 1;
				margin-left: 0;
				padding-right: 4.2rem;
				.itemT{
					display: flex;
					align-items: center;
					margin-top: 1.2rem;
					.text{
						font-size: 1.2rem;
						line-height: 2rem;
						flex: 1;
						margin-left: 1.2rem;
						border-bottom: solid 1px #F73100;
						padding-bottom: 1.2rem;
						
					}
					.iconT{
						flex: 0 0 12.5rem;
						padding-bottom: 1.2rem;
						.icon{
							width: 3rem;
							height: 3rem;
							margin: auto;
						}
						.t{
							font-size: 1.2rem;
							margin-top: .6rem;
							line-height: 1.4rem;
							text-align: center;
							font-family: 'HarmonyOS_Sans_SC_Medium';
						}
					}
					&:last-child{
						.text{
							border-bottom: 0;
						}
							
					}
				}
			}
			.left{
				flex: 0 0 30rem;
				padding: 0 0 0 4.1rem;
				.titleT{
					font-size: 2.2rem;
					font-family: 'HarmonyOS_Sans_SC_Bold';
					line-height: 3.6rem;
				}
				.btn{
					display: flex;
					align-items: center;
					cursor: pointer;
					margin-top: 6.5rem;
					.t{
						font-size: 1.2rem;
						color: #F73100;
						
					}
					.icon{
						width: .8rem;
						height: .8rem;
						margin-left: .4rem;
						margin-top: .4rem;
					}
				}
			}
		}
		
	}
	.dataBlock4{
		background-image: url('@/assets/bg@1x.jpg');
		background-size: contain;
		background-repeat: no-repeat;
		margin-top: 4.5rem;
		padding: 5rem 0;
		.content{
			padding: 0 9rem;
			.titleBox{
				display: flex;
				align-items: center;
				padding: 0 4.2rem 2.5rem 4.2rem;
				position: relative;
				&::after{
					content: '';
					background: linear-gradient(to right, rgba(255, 255, 255, 0) 92%, #FFFFFF 99%), linear-gradient(to right, #FFFFFF 0%, rgba(255, 255, 255, 0) 12%), #B0B0B0;
					position: absolute;
					width: 100%;
					left: 0;
					bottom: 0;
					height: 1px;
					opacity: 0.3;
				}
				.num{
					font-size: 3.8rem;
					color: #F73100;
					font-family: '900Heavy'
				}
				.t{
					color: #1F1F1F;
					font-weight: 400;
					margin-left: 1.2rem;
					flex: 1;
					.tt{
						font-size: 2.3rem;
						font-family: "HarmonyOS_Sans_SC_Bold";
					}
					
				}
				.btnT{
					
					margin-left: .3rem;
					position: relative;
					display: flex;
					z-index: 999;
					&:hover{
						.showCode{
							display: block;
						}
					}
					.tt{
						font-size: 1rem;
						color: #fff;
						font-family: 'HarmonyOS_Sans_SC_Medium';
						cursor: pointer;
						background-color: #F73100;
						border-radius: .2rem;
						padding: .8rem 1.2rem;
					}
					.showCode{
						position: absolute;
						top: 3rem;
						left: 0;
						width: 100%;
						display: none;
						.text{
							position: absolute;
							width: 100%;
							text-align: center;
							left: 0;
							top: 1.2rem;
							.s{
								font-size: .9rem;
								color: #fff;
							}
						}
						.img{
							width: 100%;
							padding-top: .3rem;
						}
					}
				}
			}
			.ts{
				font-size: 1.6rem;
				line-height: 2.9rem;
				font-family: 'HarmonyOS_Sans_SC_Bold';
				margin-top: 2.5rem;
				padding: 0 4.2rem 0 4.2rem;
			}
			.swiperBox{
				position:relative;
				padding: 0 3.2rem 0 3.2rem;
				:deep(.swiper-slide) {
					padding: 2.5rem 0;
				}
				.prevSlide{
					background-image: url('../../assets/i131.png');
					width: 2.1rem;
					height: 4.1rem;
					background-size: cover;
					position:absolute;
					top: 50%;
					left: 1.2rem;
					transform: translate(0,-50%);
					cursor: pointer;
					z-index: 9;
				}
				.nextSlide{
					background-image: url('../../assets/i132.png');
					width: 2.1rem;
					height: 4.1rem;
					background-size: cover;
					position:absolute;
					top: 50%;
					right: 1.2rem;
					transform: translate(0,-50%);
					cursor: pointer;
					z-index: 9;
				}
				.itemBoxT{
					padding: 0 .6rem;
				}
				.itemBox{
					position: relative;
					padding: 3.2rem 1rem;
					background: linear-gradient(151deg, rgba(221, 223, 225, 0) 63%, rgba(221, 223, 225, 0.2) 102%), #FFFFFF;
					box-shadow: 0px 8px 20px 5px rgba(121, 113, 110, 0.1);
					cursor: pointer;
					.imgBg{
						position: absolute;
						bottom: 0;
						right: 0;
						width: 14rem;
						z-index: 0;
					}
					.titleT{
						font-size: 1.5rem;
						font-family: 'HarmonyOS_Sans_SC_Bold';
					}
					.tt{
						font-size: 1.2rem;
						margin-top: .6rem;
						font-family: 'HarmonyOS_Sans_SC_Medium';
						line-height: 1.6rem;
						height: 3.2rem;
					}
					.itBox{
						margin-top: 1.8rem;
						position: relative;
						z-index: 9;
						.it{
							display: flex;
							align-items: center;
							margin-bottom: .8rem;
							.i{
								width: 1.3rem;
								height: 1.3rem;
							}
							.t{
								flex: 1;
								margin-left: .6rem;
								font-size: 1rem;
							}
						}
					}
					.btn{
						display: flex;
						align-items: center;
						cursor: pointer;
						margin-top: 6rem;
						position: relative;
						z-index: 9;
						.t{
							font-size: .9rem;
							color: #F73100;
						}
						.icon{
							width: .8rem;
							height: .8rem;
							margin-left: .4rem;
							margin-top: .3rem;
						}
					}
				}
			}
			.itemBoxTb{
				margin-top: 4rem;
				padding: 0 4.1rem;
				.t{
					font-size: 1.6rem;
					font-family: 'HarmonyOS_Sans_SC_Bold';
				}
				.itemBoxNum{
					display: flex;
					justify-content: space-between;
					margin-top: 2.5rem;
					.itemT{
						margin-right: 3rem;
						&:last-child{
							margin-right: 0;
						}
						.item{
							display: flex;
							align-items: center;
							position: relative;
							&::after{
								content: '';
								background-image: url('@/assets/i14.png');
								background-repeat: no-repeat;
								background-size: 1.6rem 1.6rem;
								position: absolute;
								top: 0rem;
								left: -.4rem;
								width: 1.6rem;
								height: 1.6rem;
							}
							.num{
								font-size: 2rem;
								font-family: '800ExtraBold';
							}
							.lable{
								font-size: 1.4rem;
								color: #767676;
								margin-left: .4rem;
								line-height: 1.1rem;
							}
						}
						.msg{
							font-size: 1.1rem;
							line-height: 1.8rem;
							margin-top: 1.5rem;
						}
					}
				}
			}
		}
	}
	.dataBlock5{
		padding: 0 0 3rem 0;
		.content{
			padding: 0 13.1rem;
			.conentTT{
				border-radius: .6rem;
				padding: 2.5rem 6.25rem;
				background: linear-gradient(114deg, rgba(221, 223, 225, 0) 71%, rgba(221, 223, 225, 0.2) 102%), #FFFFFF;
				box-shadow: 0px 8px 30px 5px rgba(121, 113, 110, 0.1);
			}
			.titleT{
				font-size: 2.3rem;
				font-family: 'HarmonyOS_Sans_SC_Bold';
				text-align: center;
			}
			.info{
				background: #F9FAFB;
				font-size: 1.5rem;
				line-height: 2.5rem;
				padding: 1.9rem 3.5rem;
				margin-top: 3rem;
				border-radius: .6rem;
				position: relative;
				&::after{
					content: '';
					background-image: url('@/assets/i134.png');
					background-repeat: no-repeat;
					background-size: 2.55rem 3.1rem;
					position: absolute;
					top: 1.4rem;
					left: 2.3rem;
					width: 2.55rem;
					height: 3.1rem;
				}
			}
		}
	}
	.dataBlock6{
		padding: 3rem 9rem;
		.content{
			padding: 0 4.1rem;
			.itemBox{
				display: flex;
				align-items: center;
				.left{
					flex: 1;
					.t{
						font-size: 2.3rem;
						font-family: 'HarmonyOS_Sans_SC_Bold';
						line-height: 1.8rem;
					}
					.m{
						font-size: 1.4rem;
						margin-top: 2rem;
						line-height: 1.8rem;
					}
				}
				.btnT{
					
					margin-left: .3rem;
					position: relative;
					display: flex;
					z-index: 999;
					&:hover{
						.showCode{
							display: block;
						}
					}
					.tt{
						font-size: 1rem;
						color: #fff;
						font-family: 'HarmonyOS_Sans_SC_Medium';
						cursor: pointer;
						background-color: #F73100;
						border-radius: .2rem;
						padding: .8rem 1.2rem;
					}
				}
			}
		}
	}
}
.tradingBox{
	background-image: url('@/assets/i16.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	margin-top: 4.5rem;
	.dataBlock{
		padding: 0 11.2rem;
		.dataLine{
			position: relative;
			margin-top: -4rem;
			.img1{
				width: 100%;
				position: absolute;
				left: 0;
				bottom: 6rem;
				z-index: 10;
			}
			.img2{
				width: 100%;
			}
		}
		.content{
			padding: 4rem 0 8.8rem 0;
			position: relative;
			z-index: 9;
			.titleBox{
				display: flex;
				align-items: center;
				
				.num{
					font-size: 4.1rem;
					color: #1F1F1F;
					font-family: '900Heavy'
				
				}
				.t{
					font-size: 1.8rem;
					color: #1F1F1F;
					font-weight: 400;
					margin-left: 1.2rem;
					margin-top: 1rem;
				}
				.btnT{
					font-size: .9rem;
					color: #fff;
					background-color: #F73100;
					padding: 0 2.5rem;
					border-radius: .2rem;
					line-height: 3rem;
					margin-left: auto;
					position: relative;
					cursor: pointer;
					z-index: 999;
					&:hover{
						.showCode{
							display: block;
						}
					}
					.tt{
						font-size: .9rem;
						color: #fff;
					}
					.showCode{
						position: absolute;
						top: 3rem;
						left: 0;
						width: 100%;
						display: none;
						.text{
							position: absolute;
							width: 100%;
							text-align: center;
							left: 0;
							top: 1.2rem;
							.s{
								font-size: .9rem;
								color: #fff;
							}
						}
						.img{
							width: 100%;
							padding-top: .3rem;
						}
					}
					
				}
			}
			.itemBox{
				display: flex;
				margin-top: 3rem;
				justify-content: space-between;
				.item{
					flex: 0 0 calc(33.333% - .8rem);
					position: relative;
					background-color: #fff;
					box-shadow: 0px .8rem 3rem .5rem rgba(116, 116, 116, 0.1);
					
					background-repeat: no-repeat;
					background-size: cover;
					background-position: bottom;
					height: 31rem;
					margin-right: .8rem;
					&:last-child{
						margin-right: 0;
					}
					.main{
						padding: 2.9rem 2.2rem;
						.name{
							font-size: 1.4rem;
							color: #1F1F1F;
							font-family: 'HarmonyOS_Sans_SC_Bold';
						}
						.msg{
							font-size: .8rem;
							color: rgba(31, 31, 31, 0.7);
							line-height: 1.2rem;
							margin-top: 1.1rem;
						}
						.tagBox{
							margin-top: 2.4rem;
							.tag{
								display: flex;
								align-items: center;
								margin-bottom: 1.2rem;
								.i{
									width: 1.8rem;
								}
								.t{
									font-size: .9rem;
									margin-left: .7rem;
									color: #383838;
								}
							}
						}
					}
				}
				.bg1{
					background-image: url('@/assets/i22.png');
				}
				.bg2{
					background-image: url('@/assets/i23.png');
				}
				.bg3{
					background-image: url('@/assets/i28.png');
				}
			}
		}
	}
}
.newsBox{
	padding: 0 7rem;
	.title{
		text-align: center;
		background-image: url('@/assets/i2.png');
		height: 10.6rem;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		position: relative;
		margin-top: 4.5rem;
		.text{
			font-size: 2.75rem;
			font-family: 'HarmonyOS_Sans_SC_Bold';
			color: #1F1F1F;
			position: absolute;
			left: 50%;
			top: 1.8rem;
			transform: translate(-50%, 0);
			width: 100%;
		}
	}
	.content{
		padding: 0 6rem;
		margin-top: -3rem;
		.navBox{
			display: flex;
			align-items: center;
			justify-content: center;
			.btn{
				font-size: 1.2rem;
				color: #8C8C8C;
				margin: 0 3rem;
				cursor: pointer;
				position: relative;
				
			}
			.active{
				color: rgba(0, 0, 0, 1);
				font-family: 'HarmonyOS_Sans_SC_Medium';
				&::after{
					content: '';
					position: absolute;
					width: 100%;
					bottom: .2rem;
					background: radial-gradient(600% 600% at 25% -253%, rgba(255, 214, 200, 0.8) 0%, rgba(254, 217, 186, 0.304) 58%, rgba(255, 184, 170, 0) 97%), #FF7070;
					height: .5rem;
					left: 50%;
					z-index: -1;
					opacity: 0.6;
					transform: translate(-50%,0);
				}
			}
		}
		.newBox{
			display: flex;
			margin-top: 3rem;
			.right{
				flex: 1;
				.list{
					margin-bottom: 1.8rem;
					cursor: pointer;
					&:last-child{
						margin-bottom: 0;
					}
					.info{
						flex: 1;
						.t{
							font-size: 1.2rem;
							color: #1F1F1F;
							white-space: break-spaces;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							overflow: hidden;
							font-family: 'HarmonyOS_Sans_SC_Bold';
						}
						.m{
							font-size: 1rem;
							color: #434343;
							margin-top: 1.2rem;
							white-space: break-spaces;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 1;
							-webkit-box-orient: vertical;
							overflow: hidden;
						}
					}
					.moreTime{
						margin-top: 1.2rem;
						display: flex;
						align-items: center;
						.more{
							display: flex;
							align-items: center;
							justify-content: flex-end;
							.t{
								font-size: .9rem;
								color: #8C8C8C;
							}
							.i{
								width: 1rem;
							}
						}
						.time{
							font-size: .9rem;
							color: #767676;
							flex: 1;
						}
					}
				}
			}
			.left{
				flex: 0 0 27rem;
				cursor: pointer;
				.time{
					font-size: .9rem;
					color: #8C8C8C;
					margin-top: 1.2rem;
				}
				.msg{
					font-size: 1rem;
					color: #434343;
					margin-top: 1.2rem;
					line-height: 1.2rem;
					white-space: break-spaces;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
				}
				.titleT{
					font-size: 1.2rem;
					color: #1F1F1F;
					margin-top: 3rem;
					font-weight: 500;
					cursor: pointer;
					white-space: break-spaces;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
					font-family: 'HarmonyOS_Sans_SC_Bold';
				}
				.imgBox{
					width: 25.4rem;
					height: 16.4rem;
					position: relative;
					&::after{
						content: '';
						width: 100%;
						height: 100%;
						background: linear-gradient(212deg, #F2F0F0 11%, rgba(255, 255, 255, 0) 167%, rgba(255, 255, 255, 0.0075) 170%);
						position: absolute;
						right: -1rem;
						bottom: -1rem;
						z-index: -1;
					}
					.img{
						width: 100%;
						height: 100%;
						
						
					}
				}
			}
			.line{
				background-color: rgba(216, 216, 216, 0.5);
				width: 1px;
				margin: 0 4rem;
				height: 23.75rem;
			}
		}
	}
	.pagination{
		display: flex;
		justify-content: center;
		padding: 3rem 0;
		
		:deep(.el-pagination){
			li{
				border: 1px solid #DEDEDE;
				margin: 0 .25rem;
				border-radius: .2rem;
				font-size: .8rem;
				min-width: 1.75rem;
				line-height: 1.75rem;
				height: 1.75rem;
				&:hover{
					color: #F73100;
					border: 1px solid #F73100;
				}
			}
			.btn-prev{
				border: 1px solid #DEDEDE;
				margin: 0 .25rem;
				border-radius: .2rem;
				min-width: 1.75rem;
				line-height: 1.75rem;
				height: 1.75rem;
				&:hover{
					color: #F73100;
					border: 1px solid #F73100;
				}
			}
			.btn-next{
				border: 1px solid #DEDEDE;
				margin: 0 .25rem;
				border-radius: .2rem;
				min-width: 1.75rem;
				line-height: 1.75rem;
				height: 1.75rem;
				&:hover{
					color: #F73100;
					border: 1px solid #F73100;
				}
			}
			.is-active{
				color: #F73100;
				border: 1px solid #F73100;
			}
		}
	}
}
.loginContent{
	.bg{
		position: fixed;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		z-index: 10000;
	}
	.contentT{
		position: fixed;
		width: 49.4rem;
		background-color: #fff;
		background-image: url('@/assets/BG_.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		z-index: 10001;
		border-radius: .6rem;
		.box{
			padding: 1.8rem;
			.close{
				width: 1rem;
				height: 1rem;
				margin-left: auto;
				cursor: pointer;
			}
			.fromBox{
				padding: 1.5rem 3rem;
				width: 17.5rem;
				.error{
					font-size: .6rem;
					color: #F73100;
					margin-top: .5rem;
					text-align: center;
					height: 1rem;
					line-height: 1rem;
				}
				.msgT{
					font-size: .65rem;
					color: #8C8C8C;
					cursor: pointer;
					margin-top: .5rem;
					text-align: center;
					.span{
						text-decoration: underline;
					}
				}
				.btnT{
					color: #F7FBFE;
					font-size: .75rem;
					font-weight: 500;
					line-height: 2.2rem;
					border-radius: .2rem;
					margin-top: .9rem;
					text-align: center;
					cursor: pointer;
					background: linear-gradient(0deg, rgba(247, 49, 0, 0.5), rgba(247, 49, 0, 0.5)), radial-gradient(159% 159% at 29% -68%, rgba(253, 224, 209, 0.5) 26%, rgba(254, 207, 150, 0.19) 58%, rgba(243, 86, 55, 0) 99%), #F34F5A;
				}
				.btnTT{
					color: #F7FBFE;
					font-size: .75rem;
					font-weight: 500;
					line-height: 2.2rem;
					border-radius: .2rem;
					margin-top: 2rem;
					text-align: center;
					cursor: pointer;
					background: linear-gradient(0deg, rgba(247, 49, 0, 0.5), rgba(247, 49, 0, 0.5)), radial-gradient(159% 159% at 29% -68%, rgba(253, 224, 209, 0.5) 26%, rgba(254, 207, 150, 0.19) 58%, rgba(243, 86, 55, 0) 99%), #F34F5A;
				}
				.forgotBox{
					display: flex;
					align-items: center;
					margin-top: 1rem;
					.jizhu{
						display: flex;
						align-items: center;
						cursor: pointer;
						line-height: 1;
						.i{
							width: .7rem;
							height: .7rem;
						}
						.t{
							font-size: .65rem;
							margin-left: .3rem;
							color: #8C8C8C;
						}
					}
					.wang{
						margin-left: auto;
						font-size: .65rem;
						color: #8C8C8C;
						cursor: pointer;
					}
				}
				
				.inputBox{
					margin-top: 1.2rem;
					.input{
						width: 100%;
						margin-bottom: .6rem;
						position: relative;
						display: flex;
						align-items: center;
						.yanma{
							position: absolute;
							font-size: .65rem;
							color: #8C8C8C;
							right: 1rem;
							top: 50%;
							transform: translate(0,-50%);
							padding-left: 1rem;
							line-height: 1;
							cursor: pointer;
							width: 3.5rem;
							text-align: center;
							&::after{
								content: '';
								position: absolute;
								width: 1px;
								height: 80%;
								background-color: rgba(140, 140, 140, 0.5);
								left: 0;
								top: 50%;
								transform: translate(0,-50%);
							}
						}
						&:last-child{
							margin-bottom: 0;
						}
						.lable{
							font-size: .65rem;
							width: 3rem;
							text-align: justify;
							margin-right: .9rem;
						}
						:deep(.el-input){
							flex: 1;
							line-height: 2.4rem;
							height: 2.4rem;
							font-size: .7rem;
							--el-input-hover-border: #F73100;
							--el-input-focus-border: #F73100;
							--el-input-hover-border-color: #F73100;
							--el-input-clear-hover-color: #F73100;
							--el-input-focus-border-color: #F73100;
							--el-input-text-color: #3D3D3D;
							--el-input-width: 100%;
							.el-input__wrapper{
								padding: 0 1rem;
							}
						}
						.codeIpnut{
							:deep(.el-input__wrapper){
								padding-right: 35%;
							}
							
						}
					}
				}
				.title{
					font-size: 1.3rem;
					font-family: 'HarmonyOS_Sans_SC_Bold';
					color: #3D3D3D;
				}	
				.navBox{
					display: flex;
					align-items: center;
					margin-top: 1.5rem;
					.t{
						position: relative;
						font-size: .8rem;
						color: #434343;
						margin-right: 3.6rem;
						cursor: pointer;
						&:last-child{
							margin-right: 0;
						}
					}
					.active{
						font-size: .8rem;
						color: rgba(0, 0, 0, 1);
						font-family: 'HarmonyOS_Sans_SC_Bold';
						&::after{
							content: '';
							position: absolute;
							width: 90%;
							bottom: 0;
							background: rgba(247, 49, 0, 0.3);
							height: .5rem;
							left: 50%;
							z-index: -1;
							transform: translate(-50%, 0)
						}
					}

				}
			}
			.fromBox2{
				width: 18.5rem;
			}
		}
	}
}
</style>
